import { t as shopify_cart_default } from "./shopify-cart-ChiJJ022.js";
import "./extender-complementary-products.js";
//#region src/scripts/extenders/product-button.js
var ProductButton = class extends HTMLElement {
	constructor() {
		super();
		const form = this.querySelector(".js-add-to-cart");
		const addToCartButton = this.querySelector("#addToBagButton");
		const quickAddButton = this.querySelector(".js-quick-add");
		const swatches = this.querySelectorAll(".color-dot");
		const variantArray = this.querySelector("#variantArray") ? JSON.parse(this.querySelector("#variantArray").innerHTML) : null;
		const tooltips = this.querySelectorAll(".tooltip");
		const changeVariant = (variant) => {
			const image = this.querySelector(".image-holder img");
			const linkElement = this.querySelector(".product-button__card-link");
			linkElement.href = variant.url;
			image.src = variant.image;
			image.srcset = variant.image;
		};
		const linkToVariant = (variant) => {
			window.location.href = variant.url;
		};
		const handleActiveDot = (swatch) => {
			swatches.forEach((swatch) => {
				swatch.classList.remove("color-dot--active");
			});
			swatch.classList.add("color-dot--active");
		};
		const hideTooltips = () => {
			tooltips.forEach((tooltip) => {
				if (tooltip.classList.contains("tooltip--active")) tooltip.classList.remove("tooltip--active");
			});
		};
		swatches.forEach((swatch) => {
			swatch.addEventListener("click", (e) => {
				e.preventDefault();
				const variantId = swatch.getAttribute("data-variant");
				const linkOption = swatch.getAttribute("data-link-mode");
				const variant = variantArray?.variants.find((variant) => variant.id === variantId);
				if (variant !== void 0) {
					if (linkOption === "link") linkToVariant(variant);
					else changeVariant(variant);
					handleActiveDot(swatch);
				}
			});
			swatch.addEventListener("mouseenter", () => {
				const tooltip = swatch.querySelector(".tooltip");
				hideTooltips();
				tooltip.classList.add("tooltip--active");
			});
			swatch.addEventListener("mouseleave", () => {
				hideTooltips();
			});
		});
		/**
		* Attach listener to the form submit buttons.
		*
		* @param event {object}
		*
		* @returns {boolean}
		*/
		const handleAddToCart = async (event) => {
			const formData = Object.fromEntries(new FormData(event.target).entries());
			if (formData.productVariant && form.checkValidity()) await shopify_cart_default.add(formData, addToCartButton);
		};
		if (form) form.addEventListener("submit", (event) => {
			event.preventDefault();
			handleAddToCart(event);
		});
		if (quickAddButton) quickAddButton.addEventListener("click", async (event) => {
			event.preventDefault();
			event.stopPropagation();
			await shopify_cart_default.quickBuy(quickAddButton.dataset.variantId, 1, quickAddButton);
		});
	}
};
if (customElements.get("product-button") === void 0) customElements.define("product-button", ProductButton);
//#endregion
